"use client";

import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { useRef, useEffect, useCallback } from "react";
//
import { useSwiperSliderOptions } from "@/lib";

export const FoundationPageScrollSection = ({
    data = {},
    slug = "sticky_scroll",
}) => {
    const { list = [] } = data;

    const scrollFixSectionRef = useRef(null);

    const {
        sliderButtons: { hasNext, hasPrev },
        nextSlide,
        prevSlide,
        options,
    } = useSwiperSliderOptions({
        clickable: true,
        slidesPerView: 7,
        modules: [Navigation],
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
            480: {
                slidesPerView: 1.5,
            },
            600: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 5,
            },
            1200: {
                slidesPerView: 7,
            },
        },
    });

    const getNavbarHeight = useCallback(() => {
        if (typeof document !== "undefined") {
            const navbar = document.querySelector(".navbar");
            return navbar ? navbar.offsetHeight : 0;
        }
        return 0;
    }, []);

    useEffect(() => {
        if (typeof window !== "undefined") {
            const setStickyStyles = () => {
                const navbarHeight = getNavbarHeight();

                const contentSections =
                    document.querySelectorAll(".content-section");
                contentSections.forEach((section) => {
                    section.style.marginTop = navbarHeight + "px";
                });

                if (scrollFixSectionRef.current) {
                    scrollFixSectionRef.current.style.position = "sticky";
                    scrollFixSectionRef.current.style.top = navbarHeight + "px";
                    scrollFixSectionRef.current.style.zIndex = "5";
                }
            };

            setStickyStyles();

            const handleResize = () => {
                setStickyStyles();
            };

            window.addEventListener("resize", handleResize);

            const handleScroll = () => {
                const navbarHeight = getNavbarHeight();
                const scrollTop = window.scrollY || window.pageYOffset;
                if (scrollTop > navbarHeight) {
                }
            };

            window.addEventListener("scroll", handleScroll);
        }

        return () => {
            window.removeEventListener("resize", handleResize);
            window.removeEventListener("scroll", handleScroll);
        };
    }, [getNavbarHeight]);

    const handleScrollTo = useCallback(
        (e, url) => {
            if (url && url.startsWith("#")) {
                e.preventDefault();
                const target = document.querySelector(url);
                if (target) {
                    const navbarHeight = getNavbarHeight();
                    const scrollFixSection = scrollFixSectionRef.current;
                    const stickyHeight = scrollFixSection
                        ? scrollFixSection.offsetHeight
                        : 0;
                    const targetRect = target.getBoundingClientRect();
                    const offset = -100;
                    const absoluteY =
                        window.pageYOffset +
                        targetRect.top -
                        stickyHeight +
                        offset;

                    window.scrollTo({
                        top: absoluteY,
                        behavior: "smooth",
                    });

                    setTimeout(() => {
                        if (window.history.replaceState) {
                            window.history.replaceState(
                                null,
                                "",
                                window.location.pathname +
                                    window.location.search
                            );
                        }
                    }, 900);
                }
            }
        },
        [getNavbarHeight]
    );

    const handleTabClick = (cta) => {
        const url = new URL(window.location);
        url.searchParams.set("type", cta?.title || "");
        window.history.pushState({}, "", url);
    };

    return (
        <>
            <section
                className="scroll__fix_section"
                id={slug}
                ref={scrollFixSectionRef}
            >
                <div className="scroll__fix_wrapper">
                    <div className="custom-container">
                        <div className="row">
                            <div className="col-12">
                                <div className="scroll__slider">
                                    <Swiper {...options}>
                                        {list.map((item, idx) => {
                                            const cta = item.cta || {};
                                            return (
                                                <SwiperSlide key={idx}>
                                                    <div className="single__item">
                                                        <div
                                                            className="heading fs-20 fw-500"
                                                            style={{
                                                                textAlign:
                                                                    "center",
                                                            }}
                                                            onClick={() =>
                                                                handleTabClick(
                                                                    cta
                                                                )
                                                            }
                                                        >
                                                            <a
                                                                className="d-inline-flex"
                                                                href={
                                                                    cta.url ||
                                                                    "#"
                                                                }
                                                                onClick={(e) =>
                                                                    handleScrollTo(
                                                                        e,
                                                                        cta.url
                                                                    )
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                    __html: cta?.title,
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </SwiperSlide>
                                            );
                                        })}
                                    </Swiper>
                                </div>
                                <ul className="scroll__slider_btn">
                                    <li
                                        className={
                                            "prev-btn-scroll" +
                                            (!hasPrev ? " disable" : "")
                                        }
                                    >
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                prevSlide();
                                            }}
                                        >
                                            <svg
                                                width={30}
                                                height={30}
                                                viewBox="0 0 45 45"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x={-1}
                                                    y={1}
                                                    width={43}
                                                    height={43}
                                                    rx="21.5"
                                                    transform="matrix(-1 0 0 1 43 0)"
                                                    stroke="#5B5B5B"
                                                    strokeWidth={2}
                                                />
                                                <path
                                                    d="M37.4685 21.1158C38.0206 21.1017 38.4797 21.5377 38.4938 22.0898C38.508 22.6419 38.0719 23.101 37.5198 23.1151L37.4685 21.1158ZM6.81525 23.6095C6.41484 23.2291 6.39861 22.5961 6.779 22.1957L12.9777 15.6707C13.3581 15.2703 13.9911 15.2541 14.3915 15.6345C14.7919 16.0148 14.8081 16.6478 14.4277 17.0482L8.91774 22.8482L14.7177 28.3582C15.1181 28.7386 15.1344 29.3715 14.754 29.772C14.3736 30.1724 13.7406 30.1886 13.3402 29.8082L6.81525 23.6095ZM37.4941 22.1155L37.5198 23.1151L7.52963 23.8841L7.50399 22.8845L7.47836 21.8848L37.4685 21.1158L37.4941 22.1155Z"
                                                    fill="#5B5B5B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                    <li
                                        className={
                                            "next-btn-scroll" +
                                            (!hasNext ? " disable" : "")
                                        }
                                    >
                                        <a
                                            href="#"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                nextSlide();
                                            }}
                                        >
                                            <svg
                                                width={30}
                                                height={30}
                                                viewBox="0 0 45 45"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <rect
                                                    x={1}
                                                    y={1}
                                                    width={43}
                                                    height={43}
                                                    rx="21.5"
                                                    stroke="#0DB02B"
                                                    strokeWidth={2}
                                                />
                                                <path
                                                    d="M7.53149 21.1158C6.97939 21.1017 6.52034 21.5377 6.50619 22.0898C6.49203 22.6419 6.92812 23.101 7.48023 23.1151L7.53149 21.1158ZM38.1848 23.6095C38.5852 23.2291 38.6014 22.5961 38.221 22.1957L32.0223 15.6707C31.6419 15.2703 31.0089 15.2541 30.6085 15.6345C30.2081 16.0148 30.1919 16.6478 30.5723 17.0482L36.0823 22.8482L30.2823 28.3582C29.8819 28.7386 29.8656 29.3715 30.246 29.772C30.6264 30.1724 31.2594 30.1886 31.6598 29.8082L38.1848 23.6095ZM7.50586 22.1155L7.48023 23.1151L37.4704 23.8841L37.496 22.8845L37.5216 21.8848L7.53149 21.1158L7.50586 22.1155Z"
                                                    fill="#0DB02B"
                                                />
                                            </svg>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
